// extracted by mini-css-extract-plugin
module.exports = {"icon":"Submenu_icon__1cP8Q","active":"Submenu_active__Cfewx"};